import { Text, type TextProps } from '@loadsmart/miranda-react'

export type InformationProps = {
  /**
   * Optional text to be rendered above title
   */
  superTitle?: string
  /**
   * Text to be rendered
   */
  title: string

  /**
   * Optional text to be rendered below title
   */
  subTitle?: string

  /**
   * Determine if the text color should be disabled
   */
  disabled?: boolean

  /**
   * Determine if the text color should be inverted
   */
  inverted?: boolean
}

export function Information({
  superTitle,
  title,
  subTitle,
  disabled = false,
  inverted = false,
}: InformationProps) {
  let color: TextProps['color'] = 'color-text-primary'

  if (disabled) {
    color = 'color-text-disabled'
  } else if (inverted) {
    color = 'color-text-inverted'
  }

  return (
    <div>
      {superTitle && (
        <>
          <Text variant="body-sm" color={color}>
            {superTitle}
          </Text>
          <br />
        </>
      )}
      <Text variant="body-md-bold" color={color}>
        {title}
      </Text>
      {subTitle && (
        <>
          <br />
          <Text variant="body-sm" color={color}>
            {subTitle}
          </Text>
        </>
      )}
    </div>
  )
}
